import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaMapMarkerAlt, FaHandshake, FaGlobeEurope } from 'react-icons/fa';
import colabImage from '../assets/images/colab.png';
import './Collaborateurs.css';

const ADVANTAGE_ICONS = [FaMapMarkerAlt, FaHandshake, FaGlobeEurope];

const Collaborateurs = () => {
  const { t } = useTranslation();
  const advantages = t('collaborateursPage.advantages', { returnObjects: true });

  return (
    <div className="collaborateurs-page">
      <section className="page-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 text-center">
              <img src="/images/logo.jpeg" alt={t('common.altLogo')} className="hero-logo" />
            </div>
            <div className="col-lg-9 text-center">
              <h1 className="page-title">{t('collaborateursPage.hero.title')}</h1>
              <p className="page-subtitle">{t('collaborateursPage.hero.subtitle')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="collaborateurs-highlight py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="highlight-card">
                <div className="highlight-image-wrap">
                  <img src={colabImage} alt={t('collaborateursPage.hero.title')} className="highlight-collab-image" />
                </div>
                <h2 className="highlight-title">{t('collaborateursPage.highlight.title')}</h2>
                <p className="highlight-lead">{t('collaborateursPage.highlight.lead')}</p>
                <p className="highlight-text">{t('collaborateursPage.highlight.text')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="collaborateurs-advantages py-5">
        <div className="container">
          <div className="row g-4 justify-content-center">
            {advantages.map((adv, index) => {
              const Icon = ADVANTAGE_ICONS[index];
              return (
                <div key={index} className="col-md-6 col-lg-3">
                  <div className="advantage-card">
                    <Icon className="advantage-icon" />
                    <h3>{adv.title}</h3>
                    <p>{adv.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Collaborateurs;
